/** @override King Living: MediaCarouselFragment — ShopTheLook + base-only slides; no cursor collections (complexity). */

import gql from 'graphql-tag';

import {CarouselItemFragment} from '@amblique/contentful/app/contentful/fragments/carousel-item/carousel-item.fragment';
import {BaseImageFragment} from '@amblique/contentful/app/contentful/fragments/image/base-image.fragment';
import {BaseMediaCarouselFragment} from '@amblique/contentful/app/contentful/fragments/media-carousel/base-media-carousel.fragment';
import {BaseRichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block/base-rich-text-block.fragment';
import {BaseSectionPanelFragment} from '@amblique/contentful/app/contentful/fragments/section-panel/base-section-panel.fragment';
import {BaseShopTheLookFragment} from '@amblique/contentful/app/contentful/fragments/shop-the-look/base-shop-the-look.fragment';
import {BaseVideoFragment} from '@amblique/contentful/app/contentful/fragments/video/base-video.fragment';

export const MediaCarouselFragment = gql`
  ${CarouselItemFragment}
  ${BaseImageFragment}
  ${BaseMediaCarouselFragment}
  ${BaseRichTextBlockFragment}
  ${BaseSectionPanelFragment}
  ${BaseShopTheLookFragment}
  ${BaseVideoFragment}

  fragment MediaCarouselFragment on MediaCarousel {
    ...BaseMediaCarouselFragment

    imagesCollection(limit: 25) {
      items {
        __typename
        ... on CarouselItem {
          ...CarouselItemFragment
        }
        ... on Image {
          ...BaseImageFragment
        }
        ... on RichTextBlock {
          ...BaseRichTextBlockFragment
        }
        ... on SectionPanel {
          ...BaseSectionPanelFragment
        }
        ... on Video {
          ...BaseVideoFragment
        }
        ... on ShopTheLook {
          ...BaseShopTheLookFragment
        }
      }
    }
    thumbnailsCollection(limit: 25) {
      items {
        __typename
        ... on Image {
          ...BaseImageFragment
        }
        ... on RichTextBlock {
          ...BaseRichTextBlockFragment
        }
        ... on SectionPanel {
          ...BaseSectionPanelFragment
        }
        ... on Video {
          ...BaseVideoFragment
        }
      }
    }
  }
`;
